module.exports = __webpack_public_path__ + "img/ic-top-up-inprogress.5f675d00.png";